import React from "react";
import { Route } from "react-router-dom";
import PropTypes from 'prop-types';
import all_routes from "./all_routes";
import ProtectedRoute from "./ProtectedRoute";

// Dashboard
import Dashboard from "../feature-module/dashboard/Dashboard";
import SalesDashbaord from "../feature-module/dashboard/salesdashbaord";

// Application
import Email from "../feature-module/Application/email";

// Inventory
import ProductList from "../feature-module/inventory/productlist";
import CategoryList from "../feature-module/inventory/categorylist";
import BrandList from "../feature-module/inventory/brandlist";
import { Units } from "../feature-module/inventory/units";
import TaxList from "../feature-module/inventory/taxlist";
import QRcode from "../feature-module/inventory/GSTQRCode";
import BarcodeGenerator from "../feature-module/inventory/BarcodeGenerator";

// Manufacturing Module
import RawMaterialDispatch from "../feature-module/manufacturing/RawMaterialDispatch";
import RawMaterialReceive from "../feature-module/manufacturing/RawMaterialReceive";
import ProductionEntry from "../feature-module/manufacturing/ProductionEntry";
import ProductionHistory from "../feature-module/manufacturing/ProductionHistory";
import StockTransfer from "../feature-module/manufacturing/StockTransfer";
import WasteEntry from "../feature-module/manufacturing/WasteEntry";
import ConvertToPurchase from "../feature-module/manufacturing/ConvertToPurchase";
import ManufacturingReports from "../feature-module/manufacturing/ManufacturingReports";
import ManufacturingStock from "../feature-module/manufacturing/ManufacturingStock";
import RawMaterialPurchase from "../feature-module/manufacturing/RawMaterialPurchase";
import ManufacturingDashboard from "../feature-module/manufacturing/ManufacturingDashboard";
// Purchases
import PurchasesList from "../feature-module/purchases/purchaseslist";
import PurchaseOrderReport from "../feature-module/purchases/purchaseorderreport";
import PurchaseReturns from "../feature-module/purchases/purchasereturns";
import PurchaseOrderInvoice from "../feature-module/purchases/purchaseOrderInvoice";

// Stock
import Managestock from "../feature-module/stock/stockManagement";

// Sales
import SalesList from "../feature-module/sales/SaleList";
import AddSale from "../feature-module/sales/addSalesPage";
import SalesInvoiceReport from "../feature-module/sales/salesInvoiceReport";
import SalesReturn from "../feature-module/salesReturns/SalesReturnList";
import AddSalesReturn from "../feature-module/salesReturns/AddSaleReturnPage";
import QuotationList from "../feature-module/sales/quotationlist";
import AddQuotationPage from "../feature-module/sales/createQuotationPage";

// Expenses
import ExpensesList from "../feature-module/expenses/ExpenseList";
import ExpenseCategory from "../feature-module/expenses/ExpenseCategoryList";

// Bank
import BankAccountList from "../feature-module/bank/BankAccountList";
import BalanceSheet from "../feature-module/bank/BalanceSheet";
import TrialBalance from "../feature-module/bank/TrialBalance";
import AccountStatement from "../feature-module/bank/AccountStatement";

// Opening Balance
import OpeningBalanceReport from "../feature-module/Reports/OpeningBalanceReport";
import OpeningBalanceEntry from "../feature-module/openingBalance/OpeningBalanceEntry";

// People
import Customers from "../feature-module/people/customers";
import Suppliers from "../feature-module/people/suppliers";

// Reports
import SalesReport from "../feature-module/Reports/salesreport";
import PurchaseReport from "../feature-module/Reports/purchasereport";
import InventoryReport from "../feature-module/Reports/inventoryreport";
import Invoicereport from "../feature-module/Reports/invoicereport";
import SupplierReport from "../feature-module/Reports/supplierreport";
import CustomerReport from "../feature-module/Reports/customerreport";
import ExpenseReport from "../feature-module/Reports/expensereport";
import IncomeReport from "../feature-module/Reports/incomereport";
import TaxReport from "../feature-module/Reports/taxreport";
import ProfitLoss from "../feature-module/Reports/profitloss";

// User Management
import Users from "../feature-module/usermanagement/users";
import RolesPermissions from "../feature-module/usermanagement/rolespermissions";
import Permissions from "../feature-module/usermanagement/permissions";
import DeleteAccount from "../feature-module/usermanagement/deleteaccount";

// Pages
import Profile from "../feature-module/pages/profile";
import Lockscreen from "../feature-module/pages/lockscreen";

// Auth Pages
import Signin from "../feature-module/pages/login/signin";
import Register from "../feature-module/pages/register/register";
import ResetpasswordThree from "../feature-module/pages/resetpassword/resetpasswordThree";
import ForgotpasswordThree from "../feature-module/pages/forgotpassword/forgotpasswordThree";

// Settings
import CompanySettings from "../feature-module/settings/websitesettings/companysettings";
import RawMaterialMaster from "../feature-module/manufacturing/RawMaterialMaster";

// PropTypes for ProtectedRouteWrapper
const ProtectedRouteWrapper = ({ element, permissions = [] }) => (
  <ProtectedRoute requiredPermissions={permissions}>
    {element}
  </ProtectedRoute>
);

ProtectedRouteWrapper.propTypes = {
  element: PropTypes.node.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string)
};

ProtectedRouteWrapper.defaultProps = {
  permissions: []
};

export const publicRoutes = [
  // DASHBOARD ROUTES
  {
    id: 1,
    path: all_routes.dashboard,
    name: "dashboard",
    element: <ProtectedRouteWrapper element={<Dashboard />} />,
    route: Route,
  },
  {
    id: 2,
    path: all_routes.salesdashboard,
    name: "salesdashboard",
    element: <ProtectedRouteWrapper element={<SalesDashbaord />} />,
    route: Route,
  },

  // APPLICATION ROUTES
  {
    id: 3,
    path: all_routes.email,
    name: "email",
    element: <ProtectedRouteWrapper element={<Email />} />,
    route: Route,
  },

  // MANUFACTURING MODULE ROUTES
  {
    id: 4,
    path: all_routes.rawMaterialDispatch,
    name: "rawMaterialDispatch",
    element: <ProtectedRouteWrapper element={<RawMaterialDispatch />} permissions={['create-dispatch', 'view-dispatch']} />,
    route: Route,
  },
  {
    id: 5,
    path: all_routes.rawMaterialReceive,
    name: "rawMaterialReceive",
    element: <ProtectedRouteWrapper element={<RawMaterialReceive />} permissions={['create-receive', 'view-receive']} />,
    route: Route,
  },
  {
    id: 6,
    path: all_routes.productionEntry,
    name: "productionEntry",
    element: <ProtectedRouteWrapper element={<ProductionEntry />} permissions={['create-production', 'view-production']} />,
    route: Route,
  },
  {
    id: 7,
    path: all_routes.productionHistory,
    name: "productionHistory",
    element: <ProtectedRouteWrapper element={<ProductionHistory />} permissions={['view-production']} />,
    route: Route,
  },
  {
    id: 8,
    path: all_routes.stockTransfer,
    name: "stockTransfer",
    element: <ProtectedRouteWrapper element={<StockTransfer />} permissions={['manage-stock-transfer']} />,
    route: Route,
  },
  {
    id: 9,
    path: all_routes.wasteEntry,
    name: "wasteEntry",
    element: <ProtectedRouteWrapper element={<WasteEntry />} permissions={['create-waste', 'view-waste']} />,
    route: Route,
  },
  {
    id: 10,
    path: all_routes.convertToPurchase,
    name: "convertToPurchase",
    element: <ProtectedRouteWrapper element={<ConvertToPurchase />} permissions={['convert-production']} />,
    route: Route,
  },
  {
    id: 11,
    path: all_routes.manufacturingReports,
    name: "manufacturingReports",
    element: <ProtectedRouteWrapper element={<ManufacturingReports />} permissions={['view-manufacturing-reports']} />,
    route: Route,
  },
  {
  id: 62, // Adjust ID based on your existing IDs
  path: all_routes.manufacturingStock,
  name: "manufacturingStock",
  element: <ProtectedRouteWrapper element={<ManufacturingStock />} permissions={['view-manufacturing-stock']} />,
  route: Route,
},
{
  id: 63, // Adjust ID based on your existing IDs
  path: all_routes.rawMaterialPurchase,
  name: "rawMaterialPurchase",
  element: <ProtectedRouteWrapper element={<RawMaterialPurchase />} permissions={['create-purchase', 'view-purchase']} />,
  route: Route,
},
{
    id: 63, // Adjust ID based on your existing IDs
  path: all_routes.rawMaterialMaster,
  name: "rawMaterialMaster",
  element: <ProtectedRouteWrapper element={<RawMaterialMaster/>} permissions={['create-purchase', 'view-purchase']} />,
  route: Route,
},
{
    id: 64, // Adjust ID based on your existing IDs
     path: all_routes.manufacturingDashboard,
  name: "manufacturingDashboard",
  element: <ProtectedRouteWrapper element={<ManufacturingDashboard/>} permissions={['create-purchase', 'view-purchase']} />,
  route: Route,
},
  // INVENTORY ROUTES
  {
    id: 12,
    path: all_routes.productlist,
    name: "productlist",
    element: <ProtectedRouteWrapper element={<ProductList />} />,
    route: Route,
  },
  {
    id: 13,
    path: all_routes.categorylist,
    name: "categorylist",
    element: <ProtectedRouteWrapper element={<CategoryList />} />,
    route: Route,
  },
  {
    id: 14,
    path: all_routes.brandlist,
    name: "brandlist",
    element: <ProtectedRouteWrapper element={<BrandList />} />,
    route: Route,
  },
  {
    id: 15,
    path: all_routes.units,
    name: "units",
    element: <ProtectedRouteWrapper element={<Units />} />,
    route: Route,
  },
  {
    id: 16,
    path: all_routes.tax,
    name: "tax",
    element: <ProtectedRouteWrapper element={<TaxList />} />,
    route: Route,
  },
  {
    id: 17,
    path: all_routes.barcode,
    name: "barcode",
    element: <ProtectedRouteWrapper element={<BarcodeGenerator />} />,
    route: Route,
  },
  {
    id: 18,
    path: all_routes.qrcode,
    name: "qrcode",
    element: <ProtectedRouteWrapper element={<QRcode />} />,
    route: Route,
  },

  // PURCHASES ROUTES
  {
    id: 19,
    path: all_routes.purchaselist,
    name: "purchaselist",
    element: <ProtectedRouteWrapper element={<PurchasesList />} />,
    route: Route,
  },
  {
    id: 20,
    path: all_routes.purchaseorderreport,
    name: "purchaseorderreport",
    element: <ProtectedRouteWrapper element={<PurchaseOrderReport />} />,
    route: Route,
  },
  {
    id: 21,
    path: all_routes.purchasereturn,
    name: "purchasereturn",
    element: <ProtectedRouteWrapper element={<PurchaseReturns />} />,
    route: Route,
  },
  {
    id: 22,
    path: all_routes.purchaseOrderInvoice,
    name: "purchaseOrderInvoice",
    element: <ProtectedRouteWrapper element={<PurchaseOrderInvoice />} />,
    route: Route,
  },

  // STOCK ROUTES
  {
    id: 23,
    path: all_routes.managestock,
    name: "managestock",
    element: <ProtectedRouteWrapper element={<Managestock />} />,
    route: Route,
  },

  // SALES ROUTES
  {
    id: 24,
    path: all_routes.saleslist,
    name: "saleslist",
    element: <ProtectedRouteWrapper element={<SalesList />} />,
    route: Route,
  },
  {
    id: 25,
    path: all_routes.addsale,
    name: "addsale",
    element: <ProtectedRouteWrapper element={<AddSale />} />,
    route: Route,
  },
  {
    id: 26,
    path: all_routes.salesinvoicereport,
    name: "salesinvoicereport",
    element: <ProtectedRouteWrapper element={<SalesInvoiceReport />} />,
    route: Route,
  },
  {
    id: 27,
    path: all_routes.salesreturn,
    name: "salesreturn",
    element: <ProtectedRouteWrapper element={<SalesReturn />} />,
    route: Route,
  },
  {
    id: 28,
    path: all_routes.quotationlist,
    name: "quotationlist",
    element: <ProtectedRouteWrapper element={<QuotationList />} />,
    route: Route,
  },

  // EXPENSES ROUTES
  {
    id: 29,
    path: all_routes.expenselist,
    name: "expenselist",
    element: <ProtectedRouteWrapper element={<ExpensesList />} />,
    route: Route,
  },
  {
    id: 30,
    path: all_routes.expensecategory,
    name: "expensecategory",
    element: <ProtectedRouteWrapper element={<ExpenseCategory />} />,
    route: Route,
  },

  // BANK ROUTES
  {
    id: 31,
    path: all_routes.bankaccountlist,
    name: "bankaccountlist",
    element: <ProtectedRouteWrapper element={<BankAccountList />} />,
    route: Route,
  },
  {
    id: 32,
    path: all_routes.balancesheet,
    name: "balancesheet",
    element: <ProtectedRouteWrapper element={<BalanceSheet />} />,
    route: Route,
  },
  {
    id: 33,
    path: all_routes.trialbalance,
    name: "trialbalance",
    element: <ProtectedRouteWrapper element={<TrialBalance />} />,
    route: Route,
  },
  {
    id: 34,
    path: all_routes.accountstatement,
    name: "accountstatement",
    element: <ProtectedRouteWrapper element={<AccountStatement />} />,
    route: Route,
  },

  // OPENING BALANCE ROUTES
  {
    id: 35,
    path: all_routes.openingbalancereport,
    name: "openingbalancereport",
    element: <ProtectedRouteWrapper element={<OpeningBalanceReport />} />,
    route: Route,
  },
  {
    id: 36,
    path: all_routes.openingBalanceEntry,
    name: "openingBalanceEntry",
    element: <ProtectedRouteWrapper element={<OpeningBalanceEntry />} />,
    route: Route,
  },

  // PEOPLE ROUTES
  {
    id: 37,
    path: all_routes.customers,
    name: "customers",
    element: <ProtectedRouteWrapper element={<Customers />} />,
    route: Route,
  },
  {
    id: 38,
    path: all_routes.suppliers,
    name: "suppliers",
    element: <ProtectedRouteWrapper element={<Suppliers />} />,
    route: Route,
  },

  // REPORT ROUTES
  {
    id: 39,
    path: all_routes.salesreport,
    name: "salesreport",
    element: <ProtectedRouteWrapper element={<SalesReport />} />,
    route: Route,
  },
  {
    id: 40,
    path: all_routes.purchasereport,
    name: "purchasereport",
    element: <ProtectedRouteWrapper element={<PurchaseReport />} />,
    route: Route,
  },
  {
    id: 41,
    path: all_routes.inventoryreport,
    name: "inventoryreport",
    element: <ProtectedRouteWrapper element={<InventoryReport />} />,
    route: Route,
  },
  {
    id: 42,
    path: all_routes.supplierreport,
    name: "supplierreport",
    element: <ProtectedRouteWrapper element={<SupplierReport />} />,
    route: Route,
  },
  {
    id: 43,
    path: all_routes.customerreport,
    name: "customerreport",
    element: <ProtectedRouteWrapper element={<CustomerReport />} />,
    route: Route,
  },
  {
    id: 44,
    path: all_routes.expensereport,
    name: "expensereport",
    element: <ProtectedRouteWrapper element={<ExpenseReport />} />,
    route: Route,
  },
  {
    id: 45,
    path: all_routes.incomereport,
    name: "incomereport",
    element: <ProtectedRouteWrapper element={<IncomeReport />} />,
    route: Route,
  },
  {
    id: 46,
    path: all_routes.invoicereport,
    name: "invoicereport",
    element: <ProtectedRouteWrapper element={<Invoicereport />} />,
    route: Route,
  },
  {
    id: 47,
    path: all_routes.taxreport,
    name: "taxreport",
    element: <ProtectedRouteWrapper element={<TaxReport />} />,
    route: Route,
  },
  {
    id: 48,
    path: all_routes.profitloss,
    name: "profitloss",
    element: <ProtectedRouteWrapper element={<ProfitLoss />} />,
    route: Route,
  },

  // USER MANAGEMENT ROUTES (Admin Only)
  {
    id: 49,
    path: all_routes.users,
    name: "users",
    element: <ProtectedRouteWrapper element={<Users />} permissions={['view-users']} />,
    route: Route,
  },
  {
    id: 50,
    path: all_routes.rolespermission,
    name: "rolespermission",
    element: <ProtectedRouteWrapper element={<RolesPermissions />} permissions={['view-roles']} />,
    route: Route,
  },
  {
    id: 51,
    path: all_routes.permissions,
    name: "permissions",
    element: <ProtectedRouteWrapper element={<Permissions />} permissions={['view-permissions']} />,
    route: Route,
  },
  {
    id: 52,
    path: all_routes.deleteaccount,
    name: "deleteaccount",
    element: <ProtectedRouteWrapper element={<DeleteAccount />} permissions={['delete-users']} />,
    route: Route,
  },

  // PROFILE ROUTE (Any logged in user)
  {
    id: 53,
    path: all_routes.profile,
    name: "profile",
    element: <ProtectedRouteWrapper element={<Profile />} />,
    route: Route,
  },

  // SETTINGS ROUTES (Admin Only)
  {
    id: 54,
    path: all_routes.companysettings,
    name: "companysettings",
    element: <ProtectedRouteWrapper element={<CompanySettings />} permissions={['edit-settings']} />,
    route: Route,
  },

  // OTHER PROTECTED ROUTES
  {
    id: 55,
    path: all_routes.lockscreen,
    name: "lockscreen",
    element: <ProtectedRouteWrapper element={<Lockscreen />} />,
    route: Route,
  },
  {
    id: 56,
    path: all_routes.createquotation,
    name: "createquotation",
    element: <ProtectedRouteWrapper element={<AddQuotationPage />} />,
    route: Route,
  },
  {
    id: 57,
    path: all_routes.addsalesreturn,
    name: "addsalesreturn",
    element: <ProtectedRouteWrapper element={<AddSalesReturn />} />,
    route: Route,
  }
];

// PUBLIC ROUTES (No login required)
export const pagesRoute = [
  {
    id: 58,
    path: all_routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 59,
    path: all_routes.register,
    name: "register",
    element: <Register />,
    route: Route,
  },
  {
    id: 60,
    path: all_routes.forgotPasswordThree,
    name: "forgotPasswordThree",
    element: <ForgotpasswordThree />,
    route: Route,
  },
  {
    id: 61,
    path: all_routes.resetpasswordThree,
    name: "resetpasswordThree",
    element: <ResetpasswordThree />,
    route: Route,
  },
];